<!--
  ACard — 베이지 톤 패널
  슬롯: 기본 / title / sub / action
  prop: padding (px), bare(헤더 없이 패딩만)
-->
<template>
  <div class="a-card" :style="{ overflow }">
    <div v-if="hasHeader" class="a-card__head">
      <div class="a-card__head-text">
        <div v-if="title || $slots.title" class="a-card__title"><slot name="title">{{ title }}</slot></div>
        <div v-if="sub || $slots.sub" class="a-card__sub"><slot name="sub">{{ sub }}</slot></div>
      </div>
      <div v-if="$slots.action" class="a-card__action"><slot name="action" /></div>
    </div>
    <div class="a-card__body" :style="bodyStyle">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ACard',
  props: {
    title: { type: String, default: '' },
    sub: { type: String, default: '' },
    padding: { type: [Number, String], default: 20 },
    bare: { type: Boolean, default: false },
    /** overflow 처리: 기본 'hidden' (둥근 모서리 안 유지)
     *  팝업(datepicker, dropdown) 이 잘려보일 때 'visible' 로 설정 */
    overflow: {
      type: String,
      default: 'hidden',
      validator: (v) => ['hidden', 'visible', 'auto', 'clip'].includes(v),
    },
  },
  computed: {
    hasHeader() {
      if (this.bare) return false;
      return !!(this.title || this.sub || this.$slots.title || this.$slots.sub || this.$slots.action);
    },
    bodyStyle() {
      // `padding="20"` (문자열 숫자) 도 px 단위 자동 부착
      const raw = this.padding;
      const p = (typeof raw === 'number' || /^\d+$/.test(String(raw))) ? `${raw}px` : raw;
      return { padding: p };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_pineapple.scss';

.a-card {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: 12px;
  /* overflow는 prop으로 인라인 적용 (default: hidden) */
  font-family: $p-font-body;
  color: $p-ink;

  &__head {
    padding: 16px 20px;
    border-bottom: 1px solid $p-line;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
  }
  &__title {
    font-size: 13px;
    font-weight: 800;
    letter-spacing: -0.01em;
  }
  &__sub {
    font-size: 11px;
    color: $p-ink-soft;
    margin-top: 2px;
  }
  &__action { flex-shrink: 0; }
  &__body { color: $p-ink; }
}
</style>
